import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
// import { email } from '@config';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;

    & + p {
      margin-top: 14px;
    }
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Hi, I’m</h1>;
  const two = <h2 className="big-heading">Bibek Neupane.</h2>;
  const three = <h3 className="big-heading">I find flaws in software.</h3>;
  const four = (
    <>
      <p>
        I’m a computer science student at{' '}
        <a href="https://www.wpunj.edu/" target="_blank" rel="noreferrer">
          William Paterson University
        </a>{' '}
        and a Research Assistant in its{' '}
        <a
          href="https://www.wpunj.edu/cosh/departments/computer-science/Research/cybersecurity-research-lab"
          target="_blank"
          rel="noreferrer">
          Cybersecurity Research Lab
        </a>
        , where I work on AI and LLM security for web applications and servers.
      </p>

      <p>I’ve published three papers so far. Two of them won best paper.</p>

      <p>
        Last summer I was an Application Security Intern at{' '}
        <a href="https://www.eclinicalworks.com/" target="_blank" rel="noreferrer">
          eClinicalWorks
        </a>
        .
      </p>
    </>
  );

  const five = (
    <a className="email-link" href="https://drive.google.com/file/d/1V46xdTivkM6Q9MiCs4YmOO7JyT-46r3o/view?usp=sharing" target="_blank" rel="noreferrer">
      Request my Resume!
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
